import React from "react";
import "./SectorsSection.css";

const ManpowerSection = () => {
  const sectors = [
    "Corporate Offices",
    "IT Companies",
    "Manufacturing Plants",
    "Manufacturing Plants",
    "Warehouses & Logistics",
    "Hospitals & Healthcare",
    "Educational Institutions",
    "Hotels & Hospitality",
    "Retail Stores",
    "Commercial Complexes",
    "Industrial Units",
    "Residential Societies",
    "Government Facilities"
  ];

  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManpowerSection;
